import { useEffect, useMemo, useState } from "react"
import { fetchListings } from "../services/NetworkRequests"
import { dirtyUrlToFilters, generateAlgoliaQueryFromFilters } from "./filter-utlils"
const defaultActions = ["keywords", "location", "area_min-area_max", "beds_in", "price_min-price_max", "location"]
const priorityList = {
  "flats-apartments": ["keywords", "location", "area_min-area_max", "beds_in", "price_min-price_max", "location"],
  homes: ["keywords", "location", "beds_in", "area_min-area_max", "price_min-price_max", "location"],
  penthouses: ["keywords", "location", "area_min-area_max", "beds_in", "price_min-price_max", "location"],
  plots: ["keywords", "location", "price_min-price_max", "area_min-area_max", "location"],
  offices: ["keywords", "location", "price_min-price_max", "area_min-area_max", "location"],
  "farm-house": [],
  houses: ["keywords", "location", "beds_in", "area_min-area_max", "price_min-price_max", "location"],
  "upper-portions": [],
  "lower-portions": [],
  rooms: [],
  "agricultural-land": [],
  "commercial-plots": [],
  "industrial-land": [],
  "plot-files": [],
  "plot-forms": [],
  "residential-plots": [],
  buildings: [],
  "commercial-offices": [],
  factories: [],
  "other-commercial-properties": [],
  shops: [],
  warehouses: [],
}

const deleteItemFromQuery = (query, keys = []) => {
  keys.map((key) => {
    delete query[key]
  })
}
function createLevelFinder(data) {
  let callCount = 0
  const firstItem = data[0]?.externalID
  const level2Index = data.findIndex((item) => item.level === 2)
  const beforeLevel2 = level2Index > 0 ? data[level2Index - 1]?.externalID : null
  const level2ID = level2Index >= 0 ? data[level2Index]?.externalID : null

  return function next() {
    callCount++
    if (callCount === 1) {
      return firstItem
    } else if (callCount === 2) {
      return beforeLevel2
    } else {
      return level2ID
    }
  }
}

export function useAlgoliaHitsByIDs(parentquery, ids = [], maxHits = 15, existings_hits) {
  const [hits, setHits] = useState([])
  const [isDone, setIsDone] = useState(false)
  const [loading, setLoading] = useState(false)
  const query = useMemo(() => parentquery, [parentquery])
  const next = createLevelFinder(ids)
  let location_external_id = next()
  let action_slug
  if (Array.isArray(query?.searchSlug)) {
    action_slug = query?.searchSlug[1]?.split("-")[0]
  } else {
    action_slug = query?.searchSlug?.split("-")[0]
  }
  const action_array = priorityList[action_slug] || defaultActions

  useEffect(() => {
    if (!ids || ids.length === 0) return
    let cancelled = false
    setHits([])
    setIsDone(false)
    setLoading(true)

    const fetchHits = async () => {
      const localHits = []
      const exclude_ids = existings_hits.map((item) => item?.id)

      for (let action_item of action_array) {
        if (cancelled || localHits.length >= maxHits) break
        let key = action_item
        try {
          if (action_item.includes("-")) {
            action_item = action_item.split("-")
          } else {
            action_item = [action_item]
          }
          deleteItemFromQuery(query, action_item)

          let newQuery = { ...query }
          if (Array.isArray(query?.searchSlug)) {
            newQuery["searchSlug"] = query?.searchSlug[1]
          } else {
            newQuery["searchSlug"] = query?.searchSlug
          }
          const filters = dirtyUrlToFilters(newQuery)

          if (key === "location") {
            location_external_id = next()
          }
          filters["location_id"] = location_external_id
          if (!filters["type"]) {
            filters["type"] = query?.type
          }
          const algoliaQueryObj = generateAlgoliaQueryFromFilters(newQuery, filters)
          const excludeClause = exclude_ids.map((id) => `NOT objectID:${id}`).join(" AND ")
          // Append or merge it with existing filters
          if (exclude_ids.length > 0) {
            algoliaQueryObj["filters"] += ` AND ${excludeClause}`
          }
          const result = await fetchListings("", algoliaQueryObj, "")
          const hits = result?.hits || []
          const filteredHits = hits.filter((hit) => !exclude_ids.includes(hit.id))
          // Extract the IDs to append
          const idsToAppend = filteredHits.map((hit) => hit.id)
          idsToAppend.map((item) => {
            exclude_ids.push(item)
          })

          if (!cancelled && result?.hits?.length > 0) {
            localHits.push(...result.hits)

            if (localHits.length >= maxHits) {
              setIsDone(true)
              break
            }
          }
        } catch (err) {
          console.error("Algolia search error:", err)
        }
      }

      if (!cancelled) {
        setHits(localHits.slice(0, maxHits))
        setLoading(false)
        setIsDone(true)
      }
    }

    fetchHits()

    return () => {
      cancelled = true
    }
  }, [ids, query])

  return { hits, isDone, loading }
}
